import useCustomIcon from '@/utilities/composables/useCustomIcon';

const ICON_END = 'end';
const ICON_MIDDLE = 'middle';
const ICON_LINE = 'line';

export default function useChildBranchIcons() {
  const { iconPath, getCustomIconStyle } = useCustomIcon();

  const getBranchIcon = (icon: string) => {
    const name = `child-branch-${icon}-thin`;
    return iconPath(name);
  };

  const getBranchIconStyle = (i: number, propsParam: any) => {
    const iconDefaultColor = 'var(--dividers)';
    const baseStyle = {
      height: '40px',
      backgroundColor: iconDefaultColor,
    };

    if (i === propsParam.depth && propsParam.lastItem) {
      return {
        ...baseStyle,
        ...getCustomIconStyle(getBranchIcon(ICON_END)),
        height: '21px',
      };
    }
    if (!propsParam.depthSiblings.includes(i)) {
      return {};
    }
    if (i < propsParam.depth) {
      return {
        ...baseStyle,
        ...getCustomIconStyle(getBranchIcon(ICON_LINE)),
      };
    }
    return {
      ...baseStyle,
      ...getCustomIconStyle(getBranchIcon(propsParam.lastItem ? ICON_END : ICON_MIDDLE)),
      height: propsParam.lastItem ? '21px' : '40px',
    };
  };

  return {
    getBranchIconStyle,
  };
}
